import styled from "styled-components";

import { MainContainer } from "@/shared/layout/Layout";

export const StyledCheckoutMainContainer = styled(MainContainer)`
    position: relative;
    padding-bottom: 8px;

    display: flex;
    flex-direction: column;
    gap: 8px;

    .ant-collapse {
        background-color: transparent;
    }
    .ant-collapse-item-active {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
`;
